import { Currency } from '@/api/types/public';
import { ColorItem } from '@/app/_lens-components/types';
import {
  getDiscountPercent,
  getMinColorItem,
  handleColorItemPriceInfo,
  hasColorItemMemberPrice,
} from '@/app/_lens-components/utils';
import { ResponsiveContext } from '@/components/Responsive/ResponsiveProvider';
import { useStore } from '@/providers/app-store-provider';
import logger from '@/utils/client-logger';
import { EPlatform } from '@/utils/enums/platform-enum';
import { formatPriceNumberWithSymbol } from '@/utils/price';
import React, { useContext, useEffect, useState } from 'react';

export default function Price({
  renderPrice,
  currency,
  currencyName,
  colorItem,
  colorList,
  hasIndexPrice = false,
}: {
  renderPrice: (
    price?: string,
    sellPrice?: string,
    discountPercent?: number,
    hasMemberPrice?: boolean,
  ) => React.ReactNode;
  currency?: Currency;
  currencyName?: string;
  colorItem?: ColorItem;
  colorList?: ColorItem[];
  hasIndexPrice?: boolean; // 配镜流程类型中是否包含折射率价格
}) {
  const { deviceType } = useContext(ResponsiveContext);

  let isWap = false;
  if ([EPlatform.ANDROID, EPlatform.IOS, EPlatform.WAP].includes(deviceType)) {
    isWap = true;
  }

  const currencyList = useStore((state) => state.currencyList);
  const currencyStore = useStore((state) => state.currency);
  const [nowCurrency] = useState<Currency>(
    currency || currencyList.find((item) => item.name === currencyName) || currencyStore,
  );
  const userInfo = useStore((state) => state.userInfo);
  const [nowPrice, setNowPrice] = useState<string>('');
  const [nowSellPrice, setNowSellPrice] = useState<string>('');
  const [discountPercent, setDiscountPercent] = useState<number>(0);
  const [hasMemberPrice, setHasMemberPrice] = useState<boolean>(false);
  useEffect(() => {
    try {
      if (colorList) {
        colorItem = getMinColorItem(colorList, hasIndexPrice, userInfo);
      }
      if (colorItem) {
        const nowPriceInfo = handleColorItemPriceInfo(
          colorItem,
          hasIndexPrice,
          nowCurrency,
          userInfo,
        );

        setNowPrice(nowPriceInfo?.price);
        setNowSellPrice(nowPriceInfo?.sell_price);
        setDiscountPercent(
          getDiscountPercent(colorItem, hasIndexPrice, nowCurrency, userInfo, isWap),
        );
        setHasMemberPrice(hasColorItemMemberPrice(colorItem, userInfo, hasIndexPrice));
      }
    } catch (error) {
      logger.error(error);
    }
  }, []);
  return renderPrice(
    nowPrice !== nowSellPrice && nowPrice ? formatPriceNumberWithSymbol(nowPrice, nowCurrency) : '',
    nowSellPrice ? formatPriceNumberWithSymbol(nowSellPrice, nowCurrency) : '',
    discountPercent,
    hasMemberPrice,
  );
}
